(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-configurator"] && !Shopify.designMode) return;
  try {
    
(function() {
  var matNames = {
    'PLA Standard': true,
    'PETG': true,
    'ABS': true,
    'Nylon (PA)': true,
    'TPU': true,
    'Resin (SLA)': true
  };
  var matLabels = ['PLA Standard','PETG','ABS','Nylon (PA)','TPU','Resin (SLA)'];

  function psCalc() {
    var sel = document.getElementById('ps-material');
    if (!sel) return;
    var rate = parseFloat(sel.value) || 3;
    var idx = sel.selectedIndex;
    var l = parseFloat(document.getElementById('ps-l').value) || 100;
    var b = parseFloat(document.getElementById('ps-b').value) || 50;
    var h = parseFloat(document.getElementById('ps-h').value) || 30;
    var qty = parseInt(document.getElementById('ps-qty').value) || 1;
    var vol = Math.round((l * b * h) / 1000 * 0.3);
    var unit = Math.round(vol * rate);
    var total = unit * qty;
    document.getElementById('ps-est-mat').textContent = matLabels[idx] || 'PLA Standard';
    document.getElementById('ps-est-dims').textContent = Math.round(l) + '×' + Math.round(b) + '×' + Math.round(h) + ' mm';
    document.getElementById('ps-est-vol').textContent = '~' + vol + ' cm³';
    document.getElementById('ps-est-unit').textContent = '~' + unit + ' kr';
    document.getElementById('ps-est-qty').textContent = qty + ' stk';
    document.getElementById('ps-est-total').textContent = total + ' kr';
  }

  function psFileChosen(input) {
    if (input.files && input.files[0]) {
      document.getElementById('ps-file-name').textContent = input.files[0].name;
      document.getElementById('ps-file-placeholder').style.display = 'none';
      document.getElementById('ps-file-chosen').style.display = 'flex';
    }
  }

  function psClearFile() {
    document.getElementById('ps-file-input').value = '';
    document.getElementById('ps-file-placeholder').style.display = 'flex';
    document.getElementById('ps-file-chosen').style.display = 'none';
    document.getElementById('ps-file-drop').classList.remove('ps-file-drop--active');
  }

  function psHandleDrop(e) {
    e.preventDefault();
    document.getElementById('ps-file-drop').classList.remove('ps-file-drop--active');
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      var fi = document.getElementById('ps-file-input');
      fi.files = e.dataTransfer.files;
      psFileChosen(fi);
    }
  }

  function psSend() {
    var email = document.getElementById('ps-email').value;
    if (!email) { alert('Vennligst skriv inn e-post.'); return; }
    document.getElementById('ps-confirm').style.display = 'block';
    document.getElementById('ps-send-btn').disabled = true;
  }

  window.psCalc = psCalc;
  window.psFileChosen = psFileChosen;
  window.psClearFile = psClearFile;
  window.psHandleDrop = psHandleDrop;
  window.psSend = psSend;

  document.addEventListener('DOMContentLoaded', psCalc);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-faq"] && !Shopify.designMode) return;
  try {
    
function psFaqToggle(btn) {
  var item = btn.parentElement;
  var answer = item.querySelector('.ps-faq-a');
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  if (expanded) {
    answer.setAttribute('hidden', '');
  } else {
    answer.removeAttribute('hidden');
  }
}

  } catch(e) { console.error(e); }
})();
})();
